"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MathOptionsPopup = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const MathOptions2_1 = require("./MathOptions2");
const MathOptionsPopup = ({ element, closePopup }) => {
    return React.createElement(MathOptions2_1.MathOptions2, { element: element, closePopup: closePopup });
};
exports.MathOptionsPopup = MathOptionsPopup;
